export default "__VITE_ASSET__ed641d89__"